import React from 'react';
import './GrowBeyondTodayLanding.css';

const GrowBeyondTodayLanding = () => {
  const features = [
    {
      icon: '📝',
      title: '일상 행동 기록',
      description: '수면, 식사, 활동, 감정 등 자녀의 하루를 간편하게 기록합니다',
      color: '#7D9347'
    },
    {
      icon: '📊',
      title: '행동 패턴 분석',
      description: '기록 데이터를 분석하여 변화 추이와 상관관계를 시각화합니다',
      color: '#9BB167'
    },
    {
      icon: '🧪',
      title: '행동 실험',
      description: '작은 변화를 시도하고 그 효과를 직접 확인할 수 있습니다',
      color: '#8BA557'
    },
    {
      icon: '👥',
      title: '파트너 연동',
      description: '배우자와 함께 기록하면 더 정확한 분석이 가능합니다',
      color: '#6D8337'
    }
  ];

  const benefits = [
    { icon: '🌱', text: '7일 만에 변화 체감' },
    { icon: '📈', text: '객관적 데이터 기반 분석' },
    { icon: '🧩', text: '행동 간 상관관계 발견' },
    { icon: '📅', text: '주간/월간 성장 리포트' },
    { icon: '🤝', text: '공동 양육 지원' },
    { icon: '💡', text: '맞춤형 인사이트 제공' }
  ];

  return (
    <div className="gbt-container">
      {/* Hero Section */}
      <section className="gbt-hero">
        <div className="gbt-hero-content">
          <div className="gbt-hero-badge">🌿 행동 기반 가족 성장 체감</div>
          <h1 className="gbt-hero-title">
            우리 아이의 성장을<br />
            <span className="gbt-gradient-text">오늘보다</span>
          </h1>
          <p className="gbt-hero-description">
            0~7세 자녀의 일상을 기록하고<br />
            행동 변화를 데이터로 확인하세요
          </p>
          <div className="gbt-hero-buttons">
            <button className="gbt-btn-primary">
              무료로 시작하기
            </button>
            <button className="gbt-btn-secondary">
              자세히 알아보기
            </button>
          </div>
          <div className="gbt-hero-stats">
            <div className="gbt-stat-item">
              <span className="gbt-stat-number">7일</span>
              <span className="gbt-stat-label">변화 체감 시작</span>
            </div>
            <div className="gbt-stat-item">
              <span className="gbt-stat-number">30초</span>
              <span className="gbt-stat-label">일일 기록 시간</span>
            </div>
            <div className="gbt-stat-item">
              <span className="gbt-stat-number">0~7세</span>
              <span className="gbt-stat-label">맞춤 분석</span>
            </div>
          </div>
        </div>
        <div className="gbt-hero-image">
          <div className="gbt-phone-mockup">
            <img src="/api/placeholder/300/600" alt="오늘보다 앱 화면" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="gbt-features">
        <div className="gbt-section-header">
          <h2>핵심 기능</h2>
          <p>기록부터 분석까지, 자녀 성장을 위한 종합 도구</p>
        </div>
        <div className="gbt-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="gbt-feature-card" style={{'--accent-color': feature.color}}>
              <div className="gbt-feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="gbt-how-it-works">
        <div className="gbt-how-content">
          <h2>이렇게 사용해요</h2>
          <p>간편한 3단계로 자녀의 성장을 체감하세요</p>
          <div className="gbt-step-cards">
            <div className="gbt-step-card">
              <div className="gbt-step-number">01</div>
              <h3>기록하기</h3>
              <p>수면, 식사, 활동, 감정 등 자녀의 하루를 간편하게 기록합니다</p>
            </div>
            <div className="gbt-step-card">
              <div className="gbt-step-number">02</div>
              <h3>분석 확인</h3>
              <p>행동 패턴과 변화 추이를 그래프와 리포트로 확인합니다</p>
            </div>
            <div className="gbt-step-card">
              <div className="gbt-step-number">03</div>
              <h3>실험하기</h3>
              <p>작은 변화를 시도하고 그 효과를 데이터로 확인합니다</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="gbt-benefits">
        <div className="gbt-benefits-content">
          <div className="gbt-benefits-text">
            <h2>왜 오늘보다인가요?</h2>
            <p className="gbt-benefits-description">
              문제를 지적하지 않습니다.<br />
              변화를 보여드립니다.
            </p>
            <div className="gbt-benefits-list">
              {benefits.map((benefit, index) => (
                <div key={index} className="gbt-benefit-item">
                  <span className="gbt-benefit-icon">{benefit.icon}</span>
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="gbt-benefits-image">
            <img src="/api/placeholder/500/400" alt="오늘보다 분석 화면" />
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="gbt-testimonials">
        <h2>사용자 후기</h2>
        <div className="gbt-testimonials-grid">
          <div className="gbt-testimonial-card">
            <div className="gbt-stars">⭐⭐⭐⭐⭐</div>
            <p>"매일 기록하니까 아이의 수면 패턴이 보이기 시작했어요. 주간 리포트로 변화를 확인하니 정말 동기부여가 됩니다."</p>
            <div className="gbt-testimonial-author">
              <strong>김수진</strong>
              <span>36개월 아이 엄마</span>
            </div>
          </div>
          <div className="gbt-testimonial-card">
            <div className="gbt-stars">⭐⭐⭐⭐⭐</div>
            <p>"남편과 함께 기록하니 아이의 행동을 더 객관적으로 볼 수 있었어요. 파트너 연동 기능이 정말 좋습니다."</p>
            <div className="gbt-testimonial-author">
              <strong>박은주</strong>
              <span>5세 아이 엄마</span>
            </div>
          </div>
          <div className="gbt-testimonial-card">
            <div className="gbt-stars">⭐⭐⭐⭐⭐</div>
            <p>"행동 실험 기능으로 작은 변화를 시도했는데, 아이의 식습관이 눈에 띄게 좋아졌어요. 데이터로 보여주니까 확실하네요."</p>
            <div className="gbt-testimonial-author">
              <strong>이정훈</strong>
              <span>7세 아이 아빠</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="gbt-cta">
        <div className="gbt-cta-content">
          <h2>오늘부터 시작하세요</h2>
          <p>7일 안에, 우리 가족의 변화를 보여드립니다</p>
          <div className="gbt-cta-buttons">
            <button className="gbt-btn-download">
              <span>🤖</span> Google Play
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="gbt-footer">
        <div className="gbt-footer-content">
          <div className="gbt-footer-section">
            <h3>오늘보다</h3>
            <p>행동 기반 가족 성장 체감 앱</p>
          </div>
          <div className="gbt-footer-section">
            <h4>제품</h4>
            <ul>
              <li><a href="#features">기능</a></li>
              <li><a href="#how-it-works">사용법</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="gbt-footer-section">
            <h4>회사</h4>
            <ul>
              <li><a href="#about">소개</a></li>
              <li><a href="#contact">문의</a></li>
            </ul>
          </div>
          <div className="gbt-footer-section">
            <h4>법적 고지</h4>
            <ul>
              <li><a href="/growbeyondtoday/terms">이용약관</a></li>
              <li><a href="/growbeyondtoday/privacy">개인정보처리방침</a></li>
              <li><a href="/growbeyondtoday/account-deletion">계정 삭제</a></li>
            </ul>
          </div>
        </div>
        <div className="gbt-footer-bottom">
          <p>&copy; 2026 오늘보다(Grow Beyond Today). All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default GrowBeyondTodayLanding;
